module.exports = __webpack_public_path__ + "img/Kindynextyear.b51af06b.jpg";